<script setup>
// T-260, segunda metade, na leitura A escolhida pelo Douglas: cada relatório ganha um atalho
// para o analítico, em vez de cada um ganhar a própria quebra por agente, time, caixa e
// causa raiz.
//
// Por que o atalho resolve: a quebra já existe, completa, numa tela só, e com a coluna de SLA
// que o T-255 levou para lá. O que faltava era o caminho: quem estava lendo um indicador tinha
// de voltar ao menu e procurar. Duplicar a quebra em oito telas criaria oito lugares para o
// mesmo número divergir.
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const route = useRoute();
</script>

<template>
  <router-link
    :to="{
      name: 'quebras_reports',
      params: { accountId: route.params.accountId },
    }"
    class="inline-flex items-center gap-1.5 px-3 py-1 text-sm font-medium rounded-lg text-n-slate-11 hover:text-n-slate-12 hover:bg-n-alpha-1"
    :title="t('RELATORIO_EXPORTAR.ANALITICO_DICA')"
  >
    <span class="i-lucide-table-2 size-4 shrink-0" />
    {{ t('RELATORIO_EXPORTAR.ANALITICO') }}
  </router-link>
</template>
